import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Uploads a bulk onboarding Excel file.
 * POST api/BulkUpload/upload-bulk-onboarding
 * multipart/form-data: file + createdBy
 *
 * @param {File} file - Excel file (.xlsx)
 * @param {(pct: number) => void} [onProgress] - optional progress callback (0-100)
 * @returns {{ success: boolean, data?: any, message?: string }}
 */
export const uploadBulkOnboardingAction = async (file, onProgress) => {
  try {
    const loggedInUser = getUserData();
    const createdBy =
      loggedInUser?.email ||
      loggedInUser?.name ||
      loggedInUser?.username ||
      "Admin";

    const formData = new FormData();
    formData.append("file", file);
    formData.append("createdBy", createdBy);

    const response = await apiClient.post(
      ATP_API_URL.BULK_UPLOAD_ONBOARDING,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          if (onProgress && e.total) {
            onProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      },
    );

    if (response?.status === 200 && response.data) {
      const { success, message, data } = response.data;
      if (success) {
        return {
          success: true,
          data: data || [],
          message: message || "Uploaded successfully",
        };
      }
      return { success: false, message: message || "Upload failed" };
    }

    return { success: false, message: "Upload failed" };
  } catch (error) {
    console.error("[BulkUploadOnboarding] error:", error);
    return {
      success: false,
      message:
        error.response?.data?.message || error.message || "Upload failed",
    };
  }
};
